export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [5,[2]],
		"/(app)/admin": [6,[2,3]],
		"/(app)/admin/metrics": [7,[2,3]],
		"/(app)/admin/permissions": [8,[2,3]],
		"/(app)/admin/settings": [9,[2,3]],
		"/(app)/admin/users": [10,[2,3]],
		"/auth": [30],
		"/(app)/c/[id]": [11,[2]],
		"/error": [31],
		"/(app)/search": [12,[2]],
		"/s/[id]": [32],
		"/watch": [33],
		"/(app)/workspace": [13,[2,4]],
		"/(app)/workspace/functions/create": [14,[2,4]],
		"/(app)/workspace/integrations": [15,[2,4]],
		"/(app)/workspace/knowledge": [16,[2,4]],
		"/(app)/workspace/knowledge/create": [18,[2,4]],
		"/(app)/workspace/knowledge/[id]": [17,[2,4]],
		"/(app)/workspace/models": [19,[2,4]],
		"/(app)/workspace/models/create": [20,[2,4]],
		"/(app)/workspace/models/edit": [21,[2,4]],
		"/(app)/workspace/prompts": [22,[2,4]],
		"/(app)/workspace/prompts/create": [23,[2,4]],
		"/(app)/workspace/prompts/edit": [24,[2,4]],
		"/(app)/workspace/settings": [25,[2,4]],
		"/(app)/workspace/tools": [26,[2,4]],
		"/(app)/workspace/tools/create": [27,[2,4]],
		"/(app)/workspace/tools/edit": [28,[2,4]],
		"/(app)/workspace/users": [29,[2,4]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';